import { createStyles, makeStyles } from '@material-ui/core/styles';

import { colorsPalette } from '../../theme';

const useStyles = (isModal) =>
  makeStyles(() =>
    createStyles({
      wrapper: {
        position: 'relative',
        width: '100%',
        height: '100%',
      },
      bumper: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        background: colorsPalette.blackPure,
        display: 'none',
      },
      active: {
        display: 'block',
      },
      video: {
        width: '100%',
        height: '100%',
      },
      btn: {
        position: 'absolute',
        top: isModal ? 19 : 24,
        right: isModal ? 81 : 24,
      },
    }),
  );

export default useStyles;
